module.exports = __webpack_public_path__ + "img/v12.d5aca4bf.png";